/*
 *   File : folio-status.js
 *   Description : Folio status polling modal
 *   Version : v1.1
 */

import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Icon } from "../Icon";
import APIService from "../../Services/api-service";
import { closeModal } from "../../Helper/helper-function";

const FolioStatusModal = (props) => {
    const timeoutRef = useRef(null);
    console.log('timeoutRef', timeoutRef);

    useEffect(() => {
        var my_modal = document.getElementById("folio-status-modal");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.handleCancelStatusModal();
        });
    }, []);



    // Polling folio status
    useEffect(() => {
        let mounted = true;


        const _folioSync = () => {
            let url = 'order-execution/folio-sync';
            let payload = {
                "customer_id": props.customer_id
            }
            APIService(true, url, payload).then((response) => {
                if (response.status_code === 200) {
                } else {
                    // toast.error(response.message, {
                    //     type: 'error'
                    // });
                }
            });
        };

        // const _folioSyncStart = () => {
        //     let url = 'order-execution/folio-sync-start';
        //     let payload = {
        //         "customer_id": props.customer_id
        //     }
        //     APIService(true, url, payload).then((response) => {
        //         if (response.status_code === 200) {
        //             setTimeout(() => { _folioSync(); _folioStatus() }, 3000);
        //         } else {
        //             toast.error(response.message, {
        //                 type: 'error'
        //             });
        //         }
        //     });
        // };


        // const _folioStatus = () => {
        //     let is_post = true;
        //     let url = 'order-execution/folio-status';
        //     let payload = {
        //         "customer_id": props.customer_id
        //     }
        //     APIService(is_post, url, payload).then((response) => {
        //         if (!mounted) return;

        //         if (response.status_code === 200) {

        //             setTimeout(() => {
        //                 closeModal('folio-status-modal');
        //                 props.handleSuccessFolioStatus?.(response.message);
        //             }, 5000);

        //         } else if (response.status_code === 400 || response.status_code === 500) {
        //             setTimeout(() => { _folioStatus() }, 5000);
        //         } else {
        //             toast.dismiss();
        //             toast.error(response.message);
        //         }
        //     });
        // };

        // _folioSync();

        const _folioSyncStart = () => {
            let url = 'order-execution/folio-sync-start';
            let payload = {
                customer_id: props.customer_id
            };

            APIService(true, url, payload).then((response) => {
                if (response.status_code === 200) {
                    timeoutRef.current = setTimeout(() => {
                        _folioSync();
                        _folioStatus();
                    }, 3000);
                } else {
                    toast.dismiss();
                    toast.error(response.message, { type: 'error' });
                }
            });
        };


        const _folioStatus = () => {
            let is_post = true;
            let url = 'order-execution/folio-status';
            let payload = {
                customer_id: props.customer_id
            };

            APIService(is_post, url, payload).then((response) => {
                if (!mounted) return;

                if (response.status_code === 200) {
                    timeoutRef.current = setTimeout(() => {
                        closeModal('folio-status-modal');
                        props.handleSuccessFolioStatus?.();
                    }, 5000);
                }
                else if (response.status_code === 400 || response.status_code === 500) {
                    //  Retry again after 5 seconds
                    timeoutRef.current = setTimeout(() => {
                        _folioStatus();
                    }, 5000);
                }
                else {
                    toast.dismiss();
                    toast.error(response.message);
                }
            });
        };


        _folioSyncStart()

        return () => {
            mounted = false;
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };

    }, [props.customer_id]);

    return (
        <div
            className="modal fade"
            id="folio-status-modal"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="folio-status-modal"
            data-bs-backdrop="static"
        >
            <div className="modal-dialog position-relative modal-dialog-centered">
                <div className="modal-content bg-white border-radius-32px">
                    <button id="close-modal" data-bs-dismiss="modal" className="d-none"></button>

                    {/* HEADER */}
                    <div className="modal-header border-0 py-3 px-3 justify-content-end">
                        <div
                        >
                            <Icon
                                icon="close"
                                data-bs-dismiss="modal"
                                size={24}
                                className="cursor-pointer"
                            />
                        </div>
                    </div>

                    {/* BODY */}
                    <div className="modal-body d-flex flex-column align-items-center justify-content-center ">

                        <img src={require("../../Assets/Images/Order-execution/status-loader.gif")} alt="Status Loader"
                            width={206}
                            draggable={false}
                            className="ms-1 object-fit-contain" />

                        <p className="mb-0 color-eerie-black text-center e-poppins-medium e-font-18 line-height-26px">
                            Please wait while your portfolio is being synced.
                            You may place your order once the process is complete.
                        </p>

                    </div>

                </div>
            </div>
        </div>
    );
}


export default FolioStatusModal;